import React from 'react';
import { Button, useTheme } from '@mui/material';
import { useTheme as useCustomTheme } from '../../theme/ThemeProvider';

export const ActionButton = ({ children, sx = {}, ...props }) => {
  const theme = useTheme();
  const { darkMode } = useCustomTheme();
  
  return (
    <Button
      variant="contained"
      sx={{
        background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
        color: 'white',
        fontWeight: 600,
        borderRadius: 2,
        px: 3,
        py: 1.5,
        textTransform: 'none',
        fontSize: '1rem',
        transition: 'all 0.3s ease-in-out',
        boxShadow: theme.shadows[2],
        '&:hover': {
          background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
          transform: 'translateY(-2px)',
          boxShadow: theme.shadows[6],
        },
        '&:disabled': {
          background: darkMode ? 'rgba(148, 163, 184, 0.3)' : 'rgba(148, 163, 184, 0.5)',
          color: darkMode ? 'rgba(148, 163, 184, 0.7)' : 'rgba(100, 116, 139, 0.7)',
          transform: 'none',
          boxShadow: 'none',
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};
